import { Phone, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { PHONE_DISPLAY, PHONE_TEL, BTN_GOLD, BTN_OUTLINE_LIGHT } from "@/site";
import { useQuote } from "@/quote-context";

export const FinalCTA = () => {
    const { openQuote } = useQuote();
    return (
        <section id="contact" data-testid="final-cta" className="relative overflow-hidden bg-navy-950 py-20 sm:py-24 lg:py-32">
            <div className="pointer-events-none absolute -bottom-40 left-[-10%] h-[480px] w-[480px] rounded-full bg-gold/10 blur-3xl" />
            <div
                className="pointer-events-none absolute inset-0 opacity-[0.05]"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(255,255,255,.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.5) 1px, transparent 1px)",
                    backgroundSize: "72px 72px",
                }}
            />
            <div className="relative mx-auto flex w-full max-w-7xl flex-col gap-12 px-5 sm:px-8 lg:flex-row lg:items-center lg:justify-between">
                <div className="max-w-2xl">
                    <Reveal>
                        <p className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.28em] text-gold">
                            <span className="h-px w-8 bg-gold" />
                            Available 24/7
                        </p>
                    </Reveal>
                    <Reveal delay={0.08}>
                        <h2 data-testid="final-cta-heading" className="mt-4 font-display text-3xl font-semibold leading-[1.08] tracking-tight text-white sm:text-5xl">
                            Need a Locksmith? <span className="italic text-gold">We're Ready to Help.</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.16}>
                        <p className="mt-5 text-sm font-bold uppercase tracking-[0.2em] text-slate-300">
                            Residential • Commercial • Automotive • Emergency
                        </p>
                        <p className="mt-3 text-base leading-relaxed text-slate-400">
                            Call now to speak with a locksmith.
                        </p>
                    </Reveal>
                </div>
                <Reveal delay={0.2} className="shrink-0">
                    <div className="flex flex-col items-start gap-5">
                        <a
                            data-testid="final-cta-phone"
                            href={PHONE_TEL}
                            className="font-display text-4xl font-semibold text-white transition-colors hover:text-gold sm:text-5xl"
                        >
                            {PHONE_DISPLAY}
                        </a>
                        <div className="flex flex-col gap-3 sm:flex-row">
                            <a data-testid="final-cta-call-button" href={PHONE_TEL} className={BTN_GOLD}>
                                <Phone className="h-4 w-4" />
                                Call Now
                            </a>
                            <button
                                data-testid="final-cta-quote-button"
                                onClick={() => openQuote()}
                                className={BTN_OUTLINE_LIGHT}
                            >
                                Request a Quote
                                <ArrowRight className="h-4 w-4" />
                            </button>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
